import React, { FC } from 'react';
import { Link } from 'react-router';
import { ArrowRightShort, SunFill } from 'react-bootstrap-icons';
import { useSite } from '../../customFrontend/SiteContext';
import { Disclosure } from '../../customFrontend/parts';
import { SiteManifest } from '../../customFrontend/types';
import { CITIES } from './cities';

/** The call to action: opens the signup modal. */
export const Cta: FC<{ children: React.ReactNode; light?: boolean }> = ({ children, light }) => {
  const { openSignup } = useSite();
  return (
    <button type="button" className={`btn mf-cta${light ? ' mf-cta--light' : ''}`} onClick={openSignup}>
      <SunFill aria-hidden="true" className="mf-cta-sun" />
      {children}
    </button>
  );
};

/**
 * Home's city tiles: a swipeable row on phones (scroll snap), a grid of
 * three from 768px and of five from 1200px.
 */
export const CityTiles: FC = () => (
  <ul className="mf-tiles">
    {Object.values(CITIES).map((city) => (
      <li key={city.path} className={`mf-tile mf-tile--${city.slug}`}>
        <span className="mf-tile-state">{city.state}</span>
        <span className="mf-tile-name">{city.name}</span>
        <p>{city.teaser}</p>
        <Link to={city.path} className="mf-tile-link">
          Mature chat in {city.name} <ArrowRightShort aria-hidden="true" />
        </Link>
      </li>
    ))}
  </ul>
);

/** A city page's other cities: pills that wrap, at every width. */
export const CityPills: FC<{ exclude: string }> = ({ exclude }) => (
  <ul className="mf-pills">
    {Object.values(CITIES).filter((city) => city.path !== exclude).map((city) => (
      <li key={city.path}>
        {/* The state badge is the pill's ::before, so the link text stays "Mature chat in <city>" */}
        <Link to={city.path} className="mf-pill" data-state={city.state}>
          Mature chat in {city.name}
        </Link>
      </li>
    ))}
  </ul>
);

/** The site's own section above the standard footer: every page and the disclosure. */
export const SiteFooter: FC<{ site: SiteManifest }> = ({ site }) => (
  <section className="mf-site-footer" aria-label={`${site.name} across Australia`}>
    <div className="container">
      <nav aria-label="MatureFlirt cities">
        <ul className="mf-footer-links">
          <li><Link to="/">Mature chat Australia</Link></li>
          {Object.values(CITIES).map((city) => (
            <li key={city.path}><Link to={city.path}>Cougar chat {city.name}</Link></li>
          ))}
        </ul>
      </nav>
      <Disclosure name={site.name} />
    </div>
  </section>
);
